import React from 'react';
import { useTranslation } from 'react-i18next';

import { SidePanel } from '../../../components/design-system/common/SidePanel';
import { CsAgentRun } from '../../../common/models/content-studio.model';
import { RunDetail } from './RunDetail';
import { WorkBoard } from './WorkBoard';

/**
 * The agents' work, over whatever the vendor was already looking at.
 *
 * Two things through one drawer: everything, or the one run that was clicked.
 * A separate panel for a single run would be the same surface opening from the
 * same place with a different shape, and "see all work" moves between them
 * without closing anything.
 */
export const WorkSheet: React.FC<{
    open: boolean;
    onOpenChange: (open: boolean) => void;
    /** The run to show. Null shows every lane. */
    run?: CsAgentRun | null;
    onClearRun?: () => void;
}> = ({ open, onOpenChange, run, onClearRun }) => {
    const { t } = useTranslation();

    return (
        <SidePanel
            open={open}
            onOpenChange={onOpenChange}
            title={run ? t('WORK.DETAIL.TITLE') : t('WORK.TITLE')}
            description={(run ? t('WORK.DETAIL.SUBTITLE') : t('WORK.SUBTITLE')) as string}
            width="data-[side=right]:sm:max-w-[860px]"
        >
            {run ? (
                <RunDetail run={run} onOpenAll={() => onClearRun?.()} onLeave={() => onOpenChange(false)} />
            ) : (
                <WorkBoard />
            )}
        </SidePanel>
    );
};
